// Definición de defaults

export const defaultTipoReservado: TipoReservadoProps = {
    idTipoReservado:    0,
    descripcion:        '',
    activo:             false,
};

// Creación de interfaces

export interface TipoReservadoProps   {
    idTipoReservado:    number;
    descripcion:        string;
    activo:             boolean;
}